import GeneralTemplateApp from './App';
import GeneralComponentMap from './ComponentMap';

// This enables application of JS modules changes in HTML view.
// Don't remove it!
if (import.meta.hot) {
  import.meta.hot.accept();
}

// eslint-disable-next-line no-unused-vars
const css = require('../scss/style.scss');

/**
 * The only purpose of this file is to bootstrap the App component
 * to the `window` whenever the page has finished loading. All
 * work to be done with loading components and any logic to perform
 * requests or update the DOM should be done their or in a specific
 * component.
 */
(function bootstrapApp() {
  // Attach App to the window
  window.App = new GeneralTemplateApp(GeneralComponentMap);

  // Initialize all components when DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    window.App.loadPagecomponents();
    // Initialize MapSVG directory icon state sync
  });
})();
